<template>
    <div>
        <label class="form-label-class">
            {{ label }}
            <textarea class="form-input h-24" @input="noteDebounce" @focus="focus" v-model="note" :placeholder="placeholder"></textarea>
        </label>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    initialNote: String,
    label: String,
    placeholder: String,
    modelValue: [String, Object],
});

const emit = defineEmits(['apply', 'update:modelValue']);

const note = ref(props.initialNote || '');
const timer = ref(null);

watch(() => props.initialNote, (newVal) => {
    note.value = newVal || '';
});

const save = () => {
    emit('apply', note.value);
};

const focus = (e) => {
    if (note.value === '') {
        e.target.select();
    }
};

const noteDebounce = () => {
    emit('update:modelValue', note.value);
    clearTimeout(timer.value);
    timer.value = setTimeout(save, 1000);
};
</script>
